/**
 * 
 */
function calc_sizesOld() {
        var tileswidth = $(".tiles").width();
        var max_width = 450;
        var tilecount = Math.ceil(tileswidth / max_width);
        if(tileswidth < 900) {
			tilecount = 1;
        }
    	var width = Math.floor(tileswidth/tilecount);
	    if(width>=max_width){
			width = max_width;	
	    }
	    var margin = Math.floor((tileswidth%width)/(2*tilecount));
	    $(".tiles>.col-md-4").each(function() {
	       $(this).css("height", width); 
	       $(this).css("width", width);
	       $(this).css("margin-left", margin);
	       $(this).css("margin-right", margin);
	    });
    }
function calc_sizes() {
	$(window).unbind("resize",resize);
    var tileswidth = $(".tiles").width();
    var max_width = 400;
    var tilecount = Math.ceil(tileswidth / max_width);
    if(tileswidth < 800) {
		tilecount = 1;
    }
	var width = Math.floor(tileswidth/tilecount);
    if(width>=max_width){
		width = max_width;	
    }
    var margin = Math.floor((tileswidth%width)/(2*tilecount));
    $(".tiles>.col-md-4").each(function() {
       $(this).css("height", width); 
       $(this).css("width", width);
       $(this).css("margin-left", margin);
       $(this).css("margin-right", margin);
    });
    
	$(window).resize(resize);
}

function resize() {
		calc_sizes();
    }


$(window).load(function () {
		calc_sizes();
		$(window).resize(resize);
    });